import DaData from './daData';
import Dictionaries from './dictionaries';
import Orders from './orders';
import Products from './products';
import Users from './users';
import WMS from './wms';

// const baseProps = {
//   baseEndPoint: '',
// };

export class Api {
  daData: DaData;
  users: Users;
  dictionaries: Dictionaries;
  products: Products;
  orders: Orders;
  wms: WMS;
  constructor() {
    this.daData = new DaData({ baseEndPoint: '/' });
    this.users = new Users({ baseEndPoint: '/users' });
    this.dictionaries = new Dictionaries({ baseEndPoint: '/dictionaries' });
    this.products = new Products({ baseEndPoint: '/products' });
    this.orders = new Orders({ baseEndPoint: '/orders' });
    this.wms = new WMS({ baseEndPoint: '/wms' });
  }
}

export default new Api();
